import { IEventDefinition } from "@highway/mbs-analytics";
import { globalEvents } from "./events/globalEvents";
import { appEvents as globalFeaturesEvents } from "./events/globalFeaturesEvents";
import { appEvents as loanAdvisorEvents } from "./events/loanAdvisorEvents";
import { appEvents as marketingEvents } from "./events/marketingEvents";
import { appEvents as marketsEvents } from "./events/marketsEvents";
import { appEvents as realEstateEvents } from "./events/realEstateEvents";
import rercEvents from "./events/rercEvents";
import { appEvents as sampleReportEvents } from "./events/sampleReportEvents";
import { appEvents as userEvents } from "./events/userEvents";

export const mbsEvents: Record<string, IEventDefinition> = {
    ...globalEvents,
    ...globalFeaturesEvents,
    ...loanAdvisorEvents,
    ...marketingEvents,
    ...marketsEvents,
    ...realEstateEvents,
    ...rercEvents,
    ...sampleReportEvents,
    ...userEvents,
};
